import { BRAIN_GAMES } from "@/lib/brain/catalog";
import { noteOwnerSession, noteUuid } from "@/lib/noteExecutor";

export interface BrainHandoffPrefill {
  target: string;
  zen?: boolean;
  expected_user_id: string;
  expected_session_id: string;
  action_id: string;
}
export function brainHandoffDestination(target: unknown): { path: string; title: string } | null {
  if (target === "hub") return { path: "/brain-training", title: "brainAction.title" };
  if (target === "map") return { path: "/brain-training?workshop=map", title: "brain.map.title" };
  if (target === "emotion") return { path: "/brain-training?workshop=emotion", title: "brain.emotion.title" };
  const game = BRAIN_GAMES.find(item => item.key === target);
  return game ? { path: game.path, title: game.title } : null;
}
export function parseBrainHandoffPrefill(value: unknown): BrainHandoffPrefill {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("invalid_request");
  const v = value as Record<string, unknown>;
  if (!brainHandoffDestination(v.target) || !noteUuid(v.expected_user_id) || !noteUuid(v.expected_session_id) ||
    typeof v.action_id !== "string" || !/^[A-Za-z0-9._:-]{1,160}$/.test(v.action_id) ||
    v.zen !== undefined && typeof v.zen !== "boolean") throw new Error("invalid_request");
  return { target: v.target as string, expected_user_id: v.expected_user_id, expected_session_id: v.expected_session_id,
    action_id: v.action_id, ...(typeof v.zen === "boolean" ? { zen: v.zen } : {}) };
}
/** Called only by the explicit Open gesture. Preview performs no auth or I/O. */
export async function openReviewedBrainHandoff(
  input: BrainHandoffPrefill,
  options: { isCurrent: () => boolean; setZen: (value: boolean) => void; navigate: (path: string) => void },
) {
  const prefill = parseBrainHandoffPrefill(structuredClone(input));
  const guard = () => { if (!options.isCurrent()) throw new Error("invalid_session"); };
  guard(); await noteOwnerSession(prefill.expected_user_id, guard); guard();
  const destination = brainHandoffDestination(prefill.target);
  if (!destination) throw new Error("invalid_request");
  if (prefill.zen !== undefined) options.setZen(prefill.zen);
  guard(); options.navigate(destination.path);
}
